// extracted by mini-css-extract-plugin
module.exports = {"container":"IndividualFormReview_container__3hVas"};